import { ref } from 'vue';
import { analyzes } from '../../../src/utils.mjs';

const useComposable = (emits) => {
  const refs = {
    end: ref(),
    date: ref(/* @__PURE__ */ new Date()),
    days: ref([]),
    start: ref()
  };
  const utils = {
    get_result: (data) => {
      const result = {};
      if (!refs.start.value && !refs.end.value || refs.start.value && refs.end.value) {
        result.start = new Date(data.date);
      } else if (refs.end.value) {
        result.end = refs.end.value;
        result.start = new Date(data.date);
      } else {
        result.end = new Date(data.date);
        result.start = refs.start.value;
      }
      return analyzes.get_correct_date(result);
    }
  };
  const methods = {
    //* 更新函数
    date: (data) => emits("update", data),
    //* 初始化函数
    init: (data) => {
      refs.end.value = analyzes.date(data.end);
      refs.start.value = analyzes.date(data.start);
      methods.update(data.date);
    },
    //* 状态更新
    update: (date) => {
      refs.days.value = [];
      refs.date.value = date;
      const d = analyzes.get_month_start_date(refs.date.value);
      for (let i = 0; i < 42; i++) {
        const current = new Date(d.getFullYear(), d.getMonth(), d.getDate() + i);
        refs.days.value.push({
          day: current.getDate(),
          date: analyzes.string("date", current),
          year: current.getFullYear(),
          month: current.getMonth()
        });
      }
    },
    //* 检测日期状态
    get_day_status: (data) => {
      var _a;
      const result = [];
      if (((_a = refs.date.value) == null ? void 0 : _a.getMonth()) != data.month) {
        result.push("ui-other-status");
      }
      const end = refs.end.value;
      const start = refs.start.value;
      const verifyEnd = (end == null ? void 0 : end.getDate()) == data.day && (end == null ? void 0 : end.getFullYear()) == data.year && (end == null ? void 0 : end.getMonth()) == data.month;
      const verifyStart = (start == null ? void 0 : start.getDate()) == data.day && (start == null ? void 0 : start.getFullYear()) == data.year && (start == null ? void 0 : start.getMonth()) == data.month;
      if (verifyEnd || verifyStart) result.push("ui-active");
      else if (start && end) {
        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);
        const current = new Date(data.date).getTime();
        if (current <= end.getTime() && current >= start.getTime()) {
          result.push("ui-contain-status");
        }
      }
      return result.join(" ");
    }
  };
  const ons = {
    day: (data) => {
      return {
        //* 数据修改
        click: () => {
          const result = utils.get_result(data);
          refs.end.value = result.end;
          refs.start.value = result.start;
          emits("change", result);
        },
        //* 数据预览
        mouseleave: () => {
          if (refs.start.value && refs.end.value) emits("message", { start: refs.start.value, end: refs.end.value });
          else {
            emits("message", { start: void 0, end: void 0 });
          }
        },
        mouseenter: () => {
          const result = utils.get_result(data);
          emits("message", {
            end: result.end,
            start: result.start
          });
        }
      };
    }
  };
  return { ons, refs, methods };
};

export { useComposable };
//# sourceMappingURL=composable.mjs.map
